/**
 * Axios API Service
 * Központi HTTP kliens konfiguráció
 */

import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Get API Base URL from runtime config or fall back to build-time env var
 */
function getApiBaseUrl(): string {
  // Runtime config (Docker) - takes precedence
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG?.API_BASE_URL) {
    return (window as any).APP_CONFIG.API_BASE_URL;
  }

  // Build-time env var (local development)
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
}

const API_BASE_URL = getApiBaseUrl();

/**
 * Axios instance létrehozása
 */
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 másodperc
});

/**
 * Request interceptor - Bearer token hozzáadása
 */
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Token hozzáadása admin végpontokhoz
    const token = localStorage.getItem('admin_token');
    if (token && config.url?.startsWith('/api/admin')) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor - 401 kezelése
 */
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    // 401 Unauthorized - kijelentkeztetés
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');

      // Ha nem a login oldalon vagyunk, irányítsunk oda
      if (!window.location.pathname.includes('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
